import styled from 'styled-components';
import { Text15Light, Text18Bold } from '../utils/Text/Text.styles';

export const ChartCard = styled.div`
  border-radius: 16px;
  border: 1px solid #f3f4f6;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  min-height: 42rem;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ChartHeader = styled.div`
  min-height: 6rem;
  padding: 1.6rem 2rem;
  border-bottom: 1px solid #f3f4f6;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.4rem;
`;

export const ChartTitle = styled(Text18Bold)`
  letter-spacing: -0.18px;
`;

export const ChartSubtitle = styled(Text15Light)`
  opacity: 0.7;
`;

export const ChartBody = styled.div`
  flex-grow: 1;
  padding: 0.8rem 1.2rem 1.6rem;
`;

export const SpinnerContainer = styled.div`
  min-height: 30rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EmptyState = styled(Text15Light)`
  min-height: 30rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 2rem;
  opacity: 0.75;
`;
